import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

export default function HotTicker() {
  const top = [...articles].sort((a, b) => b.heat - a.heat).slice(0, 8);
  const loop = [...top, ...top];

  return (
    <section className="border-y border-background-200/80 bg-background-100/70 overflow-hidden">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-8 py-3 flex items-center gap-4">
        <span className="shrink-0 flex items-center gap-1.5 text-sm font-medium text-primary-600">
          <span className="w-5 h-5 flex items-center justify-center">
            <i className="ri-fire-fill pulse-dot"></i>
          </span>
          热榜发酵中
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="ticker-track flex items-center gap-8 w-max">
            {loop.map((item, idx) => (
              <Link
                key={`${item.id}-${idx}`}
                to={`/article/${item.id}`}
                className="flex items-center gap-2 text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap"
              >
                <span className="px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-700 text-[11px]">
                  {item.category}
                </span>
                {item.title}
                <span className="text-primary-500 text-xs">{item.heat.toLocaleString()}</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}